import { interfaces } from 'inversify';
import { container } from '../../ioc/container.config';

/**
 * React hook function, which enables getting a dependency by service type.
 * @template T
 * @param identifier The service identifier.
 */
export function useInject<T>(identifier: interfaces.ServiceIdentifier<T>) {
	if (!container) { throw new Error(); }
	return container.get<T>(identifier);
};